var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 32,
    fill: "none",
    viewBox: "0 0 65 32"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#94A3B8",
    fillRule: "evenodd",
    d: "M31 6a8.5 8.5 0 1 0 5.262 15.176l3.652 3.652a1 1 0 0 0 1.414-1.414l-3.652-3.652A8.5 8.5 0 0 0 31 6m-6.5 8.5a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0",
    clipRule: "evenodd"
  })));
};
export default SvgSearch;